import { getCurrentUser } from 'aws-amplify/auth'
import { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router'

export default function RequiresNoAuth({ children }: { children: any }) {
  const navigate = useNavigate()
  const location = useLocation()

  const [userChecked, setUserChecked] = useState(false)

  useEffect(() => {
    const checkUser = async () => {
      try {
        const usr = await getCurrentUser()
        if (usr) {
          navigate('/')
        }
      } catch (e) {}
      setUserChecked(true)
    }
    checkUser()
  }, [location, navigate])

  if (userChecked) {
    return children
  }
}
